// Public origins only. Secrets belong exclusively in the backend environment.
export const API_URL = (process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://mailfromfandem.onrender.com'
    : 'http://localhost:1000')).replace(/\/+$/, '');
